<template>
  <div class="scroll-marquee" :style="{ height: itemHeight * showNum + 'px' }">
    <div class="scroll-content" :style="{ transform: `translateY(${translateY}px)`, transition: isTransition ? 'transform 0.5s' : '' }">
      <div v-for="(item, index) in list" :key="index" class="scroll-item" :class="{ 'active': isMiddleItem(index) }" :style="{ height: itemHeight + 'px' }">
        <span class="username">{{ item.phone }}</span>
        <span>抽中了 {{ item.amount }}</span>
        <span class="time">{{ item.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'

export default {
  name: 'ScrollMarquee',
  props: {
    // 展示的数据列表
    data: {
      type: Array,
      default: () => []
    },
    // 单个item的高度
    itemHeight: {
      type: Number,
      default: 15
    },
    // 展示的数量
    showNum: {
      type: Number,
      default: 3
    },
    // 滚动间隔时间(ms)
    duration: {
      type: Number,
      default: 3000
    }
  },
  setup(props) {
    const list = ref([...props.data])
    const translateY = ref(0)
    const isTransition = ref(true)
    let timer = null

    // 判断是否是中间项
    const isMiddleItem = (index) => {
      const currentIndex = Math.abs(translateY.value) / props.itemHeight
      return index === (currentIndex + 1) % list.value.length
    }

    // 开始滚动
    const startScroll = () => {
      timer = setInterval(() => {
        isTransition.value = true
        translateY.value -= props.itemHeight

        // 当滚动到最后一项时
        if (Math.abs(translateY.value) >= (list.value.length - 1) * props.itemHeight) {
          // 先将第一条数据添加到列表末尾
          list.value = [...list.value, list.value[0]]

          // 等待当前动画完成后重置
          setTimeout(() => {
            isTransition.value = false
            translateY.value = 0
            // 重置列表，移除多余的数据
            list.value = [...props.data]
          }, 500)
        }
      }, props.duration)
    }

    onMounted(() => {
      if (props.data.length > props.showNum) {
        startScroll()
      }
    })

    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    })

    return {
      list,
      translateY,
      isTransition,
      isMiddleItem
    }
  }
}
</script>

<style lang="less" scoped>
.scroll-marquee {
  width: 100%;
  overflow: hidden;
  position: relative;

  .scroll-content {
    position: absolute;
    width: 100%;
  }

  .scroll-item {
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: PingFang SC;
    font-weight: 500;
    font-size: 12px;
    line-height: 15px;
    letter-spacing: 0;
    text-align: center;
    color: #BE1302;
    opacity: 0.4;
    transition: opacity 0.5s;
    transform: scale(0.8);

    .username {
      margin-right: 6px;
    }

    .time {
      margin-left: 6px;
    }


    &.active {
      font-size: 15px;
      //color: var(--textColor);
      opacity: 1;
      transform: scale(1);
    }
  }
}
</style>
